import { render } from "./forceClose.vue?vue&type=template&id=67211f26&scoped=true&ts=true"
import script from "./forceClose.vue?vue&type=script&lang=ts"
export * from "./forceClose.vue?vue&type=script&lang=ts"

import "./forceClose.vue?vue&type=style&index=0&id=67211f26&scoped=true&lang=scss"

import exportComponent from "/Users/star/Desktop/clz-frontend/taxi-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67211f26"]])

export default __exports__